import { render } from "./TheBand.vue?vue&type=template&id=3ed0f31d&scoped=true"
import script from "./TheBand.vue?vue&type=script&lang=js"
export * from "./TheBand.vue?vue&type=script&lang=js"

import "./TheBand.vue?vue&type=style&index=0&id=3ed0f31d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ed0f31d"]])

export default __exports__